import React, { useState } from "react";
import "./neighborhoodMatchmaker.css";

export default function NeighborhoodMatchmaker() {
  const [priority, setPriority] = useState("none");
  const [housing, setHousing] = useState("none");
  const [result, setResult] = useState(null);

  function handleMatch() {
    if (priority === "none" || housing === "none") {
      alert("Please select both options.");
      return;
    }
    if (
      priority === "jhamsikhel" ||
      (priority === "sanepa" && housing === "apt")
    ) {
      setResult({
        name: "Patan (Jhamsikhel)",
        desc: "Perfect for modern apartment living with immediate access to Kathmandu's best dining and social scenes.",
      });
    } else if (priority === "baluwatar") {
      setResult({
        name: "Baluwatar",
        desc: "Ideal for those who need to be centrally located near the political and corporate hubs on the northern side of the city.",
      });
    } else {
      setResult({
        name: "Sanepa",
        desc: "The ultimate choice for spacious standalone houses, quiet streets, and proximity to international schools.",
      });
    }
  }

  return (
    <div
      className="neighborhood-matchmaker"
      style={{
        background: "var(--bg)",
        padding: "1.5rem",
        borderRadius: "12px",
        boxShadow: "var(--shadow-xs)",
        margin: "2rem 0",
      }}
    >
      <h3 style={{ color: "var(--sky-700)", marginTop: 0 }}>
        Kathmandu Neighborhood Matchmaker
      </h3>
      <p>
        Select your priorities below to see which expat hub fits your relocation
        profile.
      </p>
      <label htmlFor="prioritySelect">
        1. What is your primary lifestyle priority?
      </label>
      <br />
      <select
        id="prioritySelect"
        value={priority}
        onChange={(e) => setPriority(e.target.value)}
        style={{ marginBottom: "1rem", width: "100%", maxWidth: "400px" }}
      >
        <option value="none">-- Select Priority --</option>
        <option value="sanepa">
          Quiet, high security, and family-friendly
        </option>
        <option value="jhamsikhel">Walkability, cafes, and nightlife</option>
        <option value="baluwatar">
          Proximity to central government & northern embassies
        </option>
      </select>
      <br />
      <label htmlFor="housingSelect">
        2. What type of housing are you looking for?
      </label>
      <br />
      <select
        id="housingSelect"
        value={housing}
        onChange={(e) => setHousing(e.target.value)}
        style={{ marginBottom: "1rem", width: "100%", maxWidth: "400px" }}
      >
        <option value="none">-- Select Housing --</option>
        <option value="house">
          Large standalone house with private garden
        </option>
        <option value="apt">Modern lock-and-leave serviced apartment</option>
      </select>
      <br />
      <button
        onClick={handleMatch}
        style={{
          backgroundColor: "var(--sky-700)",
          color: "white",
          border: "none",
          padding: "12px 20px",
          borderRadius: "4px",
          fontSize: "16px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Find My Match
      </button>
      {result && (
        <div
          style={{
            marginTop: "1.5rem",
            padding: "1rem 1.2rem",
            background: "var(--sky-50)",
            borderRadius: "8px",
          }}
        >
          <b>Your best match is:</b>
          <div
            style={{ fontSize: "1.2rem", fontWeight: 700, marginTop: "0.5rem" }}
          >
            {result.name}
          </div>
          <div style={{ marginTop: "0.3rem", color: "var(--sky-700)" }}>
            {result.desc}
          </div>
        </div>
      )}
    </div>
  );
}
